import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "@/components/icon/Icon";
const BackButton = (props) => {
  const { onBack } = props;
  const { t } = useTranslation();
  return /* @__PURE__ */ React.createElement("button", { className: "modal__back", onClick: onBack }, /* @__PURE__ */ React.createElement(Icon, { icon: "arrow" }), t("modal.back"));
};
export default BackButton;
